import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DealSheetPermissions } from '../../../../interfaces/deal-sheet/deal-sheet-permissions.interface';

@Component({
  selector: 'carfax',
  templateUrl: './carfax.component-ng.html',
  styleUrls: ['./carfax.component.scss']
})
export class CarfaxComponent implements OnInit, OnChanges {

  @Input() permissions: DealSheetPermissions;
  @Input() dealerSettings: any;
  @Input() opportunityId: string;
  @Input() vin: string;
  @Input() readonly: boolean;
  public showCarFaxLink = false;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (!this.permissions || !this.dealerSettings || !this.vin) {
      return;
    }

    this.showCarFaxLink = this.permissions.vehicleHistoryReports && this.dealerSettings.enableCarFax;
  }

}
